export default "__VITE_ASSET__f89bbead__"